export default {
    init: function () {
        this.xhr = null;
        this.calendarWrapper = $("#calendar");

        if (!this.wrapperExists()) {
            return;
        }

        this.cache = {};
        this.filters = [];
        let params = {
            firstDay: 1,
            locale: "pl",
            height: "auto",
            views: {
                dayGridMonth: {
                    dayHeaderFormat: { weekday: "long" },
                },
            },
            headerToolbar: {
                left: "prev",
                center: "title",
                right: "next",
            },
            events: (params, onSuccess, onFailure) => {
                if (this.calendar) {
                    setTimeout(() => {
                        this.loadEvents(params, onSuccess, onFailure);
                    }, 10);
                }
            },
        };
        this.calendar = new FullCalendar.Calendar(this.calendarWrapper[0], params);
        this.calendar.refetchEvents();
        this.calendar.render();

        this.buildFiltersDropdown();

        this.watchForFiltersChange();
    },

    buildFiltersDropdown: function () {
        let categories = this.calendarWrapper.data("categories");
        let html = `<div id="calendar-filter" class="calendar-filter">`;
        html += `<div class="calendar-filter__inner">`;
        html += '<div class="calendar-filter__heading">Filtruj</div>';
        html += '<div class="calendar-filter__items">';
        $.each(categories, function (i, v) {
            html += `<div class="calendar-filter__item">
                        <input type="checkbox" id="calendar-filter-${i}" value="${i}">
                        <label for="calendar-filter-${i}" class="calendar-filter__label">${v}</label>
                    </div>`;
        });
        html += "</div>";
        html += "</div>";
        $("#calendar .fc-header-toolbar").append(html);
    },

    watchForFiltersChange: function () {
        const _this = this;
        $(document).on("change", "#calendar-filter input", () => {
            let ids = [];
            $("#calendar-filter input:checked").each(function () {
                ids.push($(this).val());
            });
            this.filters = ids;
            this.calendar.refetchEvents();
        });
    },

    loadEvents: function (params, onSuccess, onFailure) {
        const startDate = this.convertDate(params.start);
        const endDate = this.convertDate(params.end);
        const key = `${startDate}-${endDate}`;
        if (this.cache[key]) {
            let events = this.filterEvents(this.cache[key].events);
            onSuccess(events);
            this.renderList(this.cache[key].list);
        } else {
            this.calendarWrapper.addClass("is-loading");
            let monthDate = this.convertDate(this.calendar.getDate());
            let blockId = this.calendarWrapper.data("block_id");
            this.xhr = $.ajax({
                url: settings.ajaxurl,
                data: {
                    action: "get_calendar_events",
                    date: monthDate,
                },
                method: "GET",
                dataType: "json",
                success: (response) => {
                    this.cache[key] = response;
                    let events = this.filterEvents(this.cache[key].events);
                    onSuccess(events);
                    this.calendarWrapper.removeClass("is-loading");
                    this.renderList(response.list);
                },
                error: (xhr) => {
                    onFailure(xhr);
                    this.calendarWrapper.removeClass("is-loading");
                },
            });
        }
    },

    filterEvents: function (events) {
        if (this.filters.length == 0) return events;

        return events.filter((event) => {
            return $.inArray(event.type, this.filters) !== -1;
        });
    },

    convertDate: function (string) {
        const date = new Date(string);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    },

    renderList: function (list) {
        if (list) {
            $("#calendar-list").html(list);
            this.filterList();
        }
    },

    filterList: function () {
        if (this.filters.length == 0) return;
        $(".event-element").addClass("grid-element--hidden");
        this.filters.forEach((id) => {
            $(".event-element--type-" + id).removeClass("grid-element--hidden");
        });
    },

    wrapperExists: function () {
        return $(this.calendarWrapper).length > 0;
    },
};
